import ProjectPresetsParentEditComponent from './presets-parent-edit.component'

export default ProjectPresetsParentEditComponent
